import {loginRequest} from '../security/authConfig';
import {msalInstance} from '../index';

function handleJacksonExceptions(errorMessage: any) {
  if (errorMessage.errors) {
    throw new Error(errorMessage.errors[0].defaultMessage)
  }
}

export async function getToken() {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
  }
  return await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: account,
  });
}

export async function callGovernanceApi(url: string, method: string, body?: object) {
  const GOVERNANCE_API_URL = process.env.API_CLIENT_GOVERNANCE_BASE_URL;
  const authResponse = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${authResponse.idToken}`;

  headers.append('Authorization', bearer);
  headers.append('Content-Type', 'application/json');

  const options: RequestInit = {
    method: method,
    headers: Object.fromEntries(headers)
  };

  if (method === 'POST' && body) {
    options.body = JSON.stringify(body);
  }

  return fetch(GOVERNANCE_API_URL + url, options)
    .then(async (response) => {
      const contentType = response.headers.get('Content-Type');
      if (!response.ok) {
        if(contentType && contentType.includes('application/json')) {
          const errorMessage = await response.json();
          handleJacksonExceptions(errorMessage);
          throw new Error(errorMessage);
        } else {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        }
      }
     return contentType && contentType.includes('application/json') ? await response.json() : await response.text();
    })
    .catch((error) => {
      throw error;
    });
}
